//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { axiosGet } from '../../axios/axios.js'
import { formatConfiguredTime } from '../../components/helpers.js'
import { getAdjacentObjectsRequests } from '../../forms/Request/Request.js'
import Table from '../../components/Table/Table.vue'
import ServiceObjectPropertyAdjacentChildren from '../ServiceObject/ServiceObjectPropertyAdjacentChildren.vue'
import ServiceObjectPropertyAdjacentParents from '../ServiceObject/ServiceObjectPropertyAdjacentParents.vue'

export default {
  components: {
    Table,
    ServiceObjectPropertyAdjacentParents,
    ServiceObjectPropertyAdjacentChildren
  },
  props: {
    objectId: {
      type: Number,
      default: null
    },
    objectType: {
      type: String,
      default: null
    },
    requestId: {
      type: [Number, Array],
      default: () => null
    },
    serviceObjectName: {
      type: String,
      default: null
    },
    requests: {
      type: Array,
      default: () => null
    }
  },
  data: function () {
    return {
      items: this.requests || [],
      columns: [
        {
          name: 'objectType',
          label: 'Тип объекта',
          field: 'objectType',
          align: 'left',
          sortable: true
        },
        {
          name: 'objectNumber',
          label: 'Номер объекта',
          field: 'objectNumber',
          align: 'left',
          sortable: true
        },
        {
          name: 'typeName',
          label: 'Тип заявки',
          field: 'typeName',
          align: 'left',
          sortable: true
        },
        {
          name: 'applicantDescription',
          label: 'Описание от заявителя',
          field: 'applicantDescription',
          align: 'left',
          sortable: true
        },
        {
          name: 'stateName',
          label: 'Статус заявки',
          field: 'stateName',
          align: 'left',
          sortable: true
        },
        {
          name: 'name',
          label: 'Номер заявки',
          field: 'name',
          align: 'left',
          sortable: true
        },
        {
          name: 'createTime',
          label: 'Дата/время создания заявки',
          field: 'createTime',
          format: val => formatConfiguredTime(val),
          align: 'left',
          sortable: true
        },
        {
          name: 'distanceText',
          label: 'Расстояние до смежного объекта',
          field: 'distanceText',
          align: 'left',
          sort: (a, b, rowA, rowB) => {
            return parseFloat(a) - parseFloat(b)
          },
          sortable: true
        },
        {
          name: 'objectAddress',
          label: 'Адрес объекта',
          field: 'objectAddress',
          align: 'left',
          sortable: true
        }
      ],
      sortFields: [
        {
          label: 'Заявка',
          value: 'name'
        },
        {
          label: 'Статус заявки',
          value: 'stateId'
        },
        {
          label: 'Тип заявки',
          value: 'typeName'
        },
        {
          label: 'Описание',
          value: 'applicantDescription'
        },
        {
          label: 'Тип объекта',
          value: 'objectType'
        },
        {
          label: 'Номер объекта',
          value: 'objectNumber'
        },
        {
          label: 'Расстояние до смежного объекта (по прямой)',
          value: 'distanceText'
        },
        {
          label: 'Адрес объекта',
          value: 'objectAddress'
        }
      ],
      sortField: 'distanceText',
      sortOrderAsc: true,
      sortOptionsDialogOpened: false,

      adjacentObjectSortOptions: [
        {
          label: 'Расстояние от текущего объекта с группировкой',
          value: 'viewObjectDistanceGroup'
        },
        {
          label: 'Расстояние от текущего объекта',
          value: 'viewObjectDistance'
        }
      ],
      adjacentObjectSortOption: 'viewObjectDistanceGroup',
      adjacentObjectSortDialogOpened: false,

      serviceObject: null,
      showAdjacentObjectsInfo: false,

      formatConfiguredTime
    }
  },
  computed: {
    ...mapGetters({
      taskStatesColors: 'getTaskStatesColors'
    }),
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    itemsSorted: function () {
      const itemsSorted = JSON.parse(JSON.stringify(this.items))
      return itemsSorted.sort((a, b) => {
        let aOverB, bOverA
        if (['typeName', 'applicantDescription', 'objectAddress', 'objectType'].includes(this.sortField)) {
          aOverB = (a[this.sortField] || '').localeCompare(b[this.sortField]) > 0
          bOverA = (b[this.sortField] || '').localeCompare(a[this.sortField]) > 0
        } else {
          const valueA = a[this.sortField] ? a[this.sortField].replace(/^[^0-9]+/, '') : ''
          const valueB = b[this.sortField] ? b[this.sortField].replace(/^[^0-9]+/, '') : ''
          aOverB = parseFloat(valueA) > parseFloat(valueB)
          bOverA = parseFloat(valueB) > parseFloat(valueA)
        }
        if (aOverB) {
          return this.sortOrderAsc ? 1 : -1
        } else if (bOverA) {
          return this.sortOrderAsc ? -1 : 1
        } else {
          return 0
        }
      })
    },
    adjacentObjectsSorted: function () {
      let adjacentObjects = []
      if (this.objectType === 'cameraTV') {
        adjacentObjects = JSON.parse(JSON.stringify(this.serviceObject.adjacentObjects || []))
      } else {
        const adjacentParents = JSON.parse(JSON.stringify(this.serviceObject.adjacentParents || []))
        adjacentParents.forEach(adjacentParent => {
          if (adjacentParent.adjacentChildren) {
            adjacentParent.adjacentChildren.forEach(adjacentChild => {
              const row = {
                parentId: adjacentParent.id,
                parentName: adjacentParent.name,
                parentKey: adjacentParent.key,
                parentType: adjacentParent.type
              }
              Object.keys(adjacentChild).forEach(key => {
                if (key !== 'adjacentChildren') {
                  row[key] = adjacentChild[key]
                }
              })
              adjacentObjects.push(row)
            })
          }
        })
      }
      return adjacentObjects.sort(this.sortServiceObjectsFn)
    }
  },
  mounted: function () {
    if (!this.requests) {
      getAdjacentObjectsRequests(this.objectId, this.requestId).then(result => {
        this.items = result
      })
    }
    this.getServiceObject(this.objectId)
  },
  methods: {
    sortServiceObjectsFn: function (a, b) {
      if (this.adjacentObjectSortOption === 'viewObjectDistance') {
        if (isNaN(parseFloat(a.viewObjectDistanceText)) && isNaN(parseFloat(b.viewObjectDistanceText))) {
          return this.compareServiceObjectsByName(a.name, b.name)
        } else if (isNaN(parseFloat(a.viewObjectDistanceText))) {
          return 1
        } else if (isNaN(parseFloat(b.viewObjectDistanceText))) {
          return -1
        }
        return parseFloat(a.viewObjectDistanceText) - parseFloat(b.viewObjectDistanceText) || this.compareServiceObjectsByName(a.name, b.name)
      } else if (this.adjacentObjectSortOption === 'viewObjectDistanceGroup') {
        if (a.parentId === b.parentId) {
          if (isNaN(parseFloat(a.viewObjectDistanceText)) && isNaN(parseFloat(b.viewObjectDistanceText))) {
            return this.compareServiceObjectsByName(a.name, b.name)
          } else if (isNaN(parseFloat(a.viewObjectDistanceText))) {
            return 1
          } else if (isNaN(parseFloat(b.viewObjectDistanceText))) {
            return -1
          }
          return parseFloat(a.viewObjectDistanceText) - parseFloat(b.viewObjectDistanceText) || this.compareServiceObjectsByName(a.name, b.name) > 0
        } else {
          return this.compareServiceObjectsByName(a.parentName, b.parentName)
        }
      }
    },
    hexToRgb: function (hex, alpha) {
      hex = hex.replace('#', '')

      const r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16)
      const g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16)
      const b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16)

      if (alpha) {
        return `rgba(${r},${g},${b},${alpha})`
      } else {
        return `rgb(${r},${g},${b})`
      }
    },
    getBpStateStyles: function (stateId) {
      const backgroundColor = this.$store.getters.getTaskStatesColors[stateId] || '#000000'
      const color = backgroundColor === '#0000FF' || backgroundColor === '#828282' || backgroundColor === '#000000' || backgroundColor === '#FF0000' ? 'white' : 'black'

      return `background: linear-gradient(45deg, ${this.hexToRgb(backgroundColor, 1)} 30%, ${this.hexToRgb(backgroundColor, 0.85)} 30%, ${this.hexToRgb(backgroundColor, 0.7)} 40%);
              color: ${color}; padding-left: 10px; padding-right: 10px; font-weight: 700;`
    },
    compareServiceObjectsByName: function (a, b) {
      const aBeforeNumber = a.replace(/[0-9]+/g, '')
      const bBeforeNumber = b.replace(/[0-9]+/g, '')
      const aNumber = a.replace(/^[^0-9]+/, '')
      const bNumber = b.replace(/^[^0-9]+/, '')
      console.log(aBeforeNumber, bBeforeNumber, aNumber, bNumber)
      return aBeforeNumber.localeCompare(bBeforeNumber) || parseFloat(aNumber) - parseFloat(bNumber)
    },
    getServiceObject: async function (objectId) {
      return axiosGet({
        url: `/service/delta/dispatcher/serviceobject?type=${this.objectType}&id=${objectId}`,
        onSuccess: (response) => {
          this.serviceObject = response.data
          return response.data
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    getTdStyle: function (col, row) {
      if (col.name === 'stateName') {
        if (this.taskStatesColors[row.stateId] === '#0000FF' || this.taskStatesColors[row.stateId] === '#000000' || this.taskStatesColors[row.stateId] === '#FF0000') {
          return this.getColoredTdStyle(this.taskStatesColors[row.stateId], 'white')
        } else {
          return this.getColoredTdStyle(this.taskStatesColors[row.stateId], 'black')
        }
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 1000) {
      if (bgColor == null) {
        bgColor = 'white'
        color = 'black'
      }
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}
